import { createConfig } from "@Utils/createConfig";
import { gatewayUrl } from "@Constants/gatewayUrl";
import axios from "axios";
export async function createSavedPrompt(token, prompt) {
    const header = createConfig(token);
    const url = `${gatewayUrl}/chats/promptBank`;
    const body = {
        ...prompt,
        isPrivate: prompt.type === "private"
    };
    try {
        const response = await axios.post(url, body, header);
        return response.data;
    } catch (error) {
        console.error("Error creating saved prompt:", error);
        throw new Error("Failed to create saved prompt");
    }
}
